import * as React from "react";

import {
  BadgeStatus,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@alaffia-technology-solutions/ds";

type TooltipTriggerProps = React.ComponentProps<typeof TooltipTrigger>;

export type FileNotReadyTooltipProps = TooltipTriggerProps;

export const FileNotReadyTooltip = (props: FileNotReadyTooltipProps) => (
  <Tooltip>
    <TooltipTrigger aria-label="File not ready" {...props}>
      <BadgeStatus>System Processing</BadgeStatus>
    </TooltipTrigger>
    <TooltipContent collisionPadding={4} className="[&_p]:af-mb-0">
      <p>This file is not ready to search yet.</p>
      <p>Please wait for the file processing to complete.</p>
    </TooltipContent>
  </Tooltip>
);
